import ColorRadiiService from "./ColorRadiiService";
import LinkService from "./LinkService";

export default class TriadHelpService {
    constructor() {
        this._linkService = new LinkService()
    }
    getPositionTitle(triadNotes, notesAtPosition) {
        let lowestString = Math.max(...notesAtPosition.map(item => item.s));
        let noteString = ""
        for (var i = 0; i < notesAtPosition.length; i++) {
            if (i < 1) {
                noteString = noteString + notesAtPosition[i].n + ", "
            } else if (i < 2) {
                noteString = noteString + notesAtPosition[i].n + " and "
            } else {
                noteString = noteString + notesAtPosition[i].n + "."
            }
        }
        for (var i = 0; i < notesAtPosition.length; i++) {
            if (notesAtPosition[i].s === lowestString) {
                let startNote = notesAtPosition[i].n
                if (triadNotes[0] === startNote) {
                    return "Root: " + noteString
                } else if (triadNotes[1] === startNote) {
                    return "1st Inversion: " + noteString
                } else {
                    return "2nd Inversion: " + noteString
                }
            }
        }
    }

    getStartingFret(minFret) {
        if(minFret==0) {
            return minFret
        }
        return minFret -1
    }
    addColorAndPaddingFrets(allNotes) {
        let colorService = new ColorRadiiService();
        let goodColor = colorService.goodColor()
        let black = colorService.black()
        let triadNotes = allNotes.notes;

        let stringCombos = allNotes.stringCombos;

        for (var sc = 0; sc < stringCombos.length; sc++) {
            let stringCombo = stringCombos[sc]
            let positions = stringCombo.positions;

            for (var p = 0; p < positions.length; p++) {
                let position = positions[p]
                let notesAtPosition = position.notesAtPosition;
                let minFret = Math.min(...notesAtPosition.map(item => item.f));
                let maxFret = Math.max(...notesAtPosition.map(item => item.f));
                let currentStringCombo = allNotes.stringCombos[sc]
                let currentPosition = currentStringCombo.positions[p]

                let positionTitle = this.getPositionTitle(triadNotes, notesAtPosition)
                let newnotesAtPosition = []
                for (var nia = 0; nia < notesAtPosition.length; nia++) {
                    let noteInfoObject = currentPosition.notesAtPosition[nia];
                    noteInfoObject['color'] = goodColor;
                    newnotesAtPosition.push(noteInfoObject)
                }
                let startingFret = this.getStartingFret(minFret)
                newnotesAtPosition.push({s: 6, f: startingFret, n: 'q', color: black})
                newnotesAtPosition.push({s: 6, f: maxFret + 1, n: 'q', color: black})
                allNotes.stringCombos[sc].positions[p].positionTitle = positionTitle
                allNotes.stringCombos[sc].positions[p].notesAtPosition = newnotesAtPosition
            }
        }
        return allNotes;
    }

    diminishedtriads() {
        let notes =
            {
                "mainTitle": "Diminished",
                "helpLink":this._linkService.THEORY_TRI_DIM,
                "detail": "Diminished triad chords begin at the root note. The next note of a diminished triad " +
                    " is three half steps " +
                    " (also called three semitones) above the root. " +
                    " The last note of the diminished triad is three half steps " +

                    " above the middle note. " +
                    "The examples below show different patterns for a B diminished triad chord. " +
                    "These patterns are identical for " +

                    "all diminished triad chords.",

                "notes": ["B", "D", "F"],
                "stringCombos": [{
                    "stringTitle": "1st, 2nd and 3rd",

                        "positions": [{
                            "notesAtPosition": [
                                {n: 'B', s: 3, f: 4},
                                {n: 'D', s: 2, f: 3},
                                {n: 'F', s: 1, f: 1},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'D', s: 3, f: 7},
                                {n: 'F', s: 2, f: 6},
                                {n: 'B', s: 1, f: 7},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'F', s: 3, f: 10},
                                {n: 'B', s: 2, f: 12},
                                {n: 'D', s: 1, f: 10},]
                        },
                    ]
                },
                    {
                        "stringTitle": "2nd, 3rd and 4th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'F', s: 4, f: 3},
                                {n: 'B', s: 3, f: 4},
                                {n: 'D', s: 2, f: 3},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'B', s: 4, f: 9},
                                    {n: 'D', s: 3, f: 7},
                                    {n: 'F', s: 2, f: 6},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'F', s: 3, f: 10},
                                    {n: 'B', s: 2, f: 12},]
                            },

                        ]
                    },
                    {
                        "stringTitle": "3rd, 4th and 5th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'D', s: 5, f: 5},
                                {n: 'F', s: 4, f: 3},
                                {n: 'B', s: 3, f: 4},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'F', s: 5, f: 8},
                                    {n: 'B', s: 4, f: 9},
                                    {n: 'D', s: 3, f: 7},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'B', s: 5, f: 14},
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'F', s: 3, f: 10},]
                            },
                        ]
                    },
                    {
                        "stringTitle": "4th, 5th and 6th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'F', s: 6, f: 1},
                                {n: 'B', s: 5, f: 2},
                                {n: 'D', s: 4, f: 0},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'B', s: 6, f: 7},
                                    {n: 'D', s: 5, f: 5},
                                    {n: 'F', s: 4, f: 3},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 6, f: 10},
                                    {n: 'F', s: 5, f: 8},
                                    {n: 'B', s: 4, f: 9},]
                            },
                        ]
                    }
                ]
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }


    minortriads() {
        let notes =
            {
                "mainTitle": "Minor",
                "helpLink":this._linkService.THEORY_TRI_MIN,
                "detail": "Minor triad chords begin at the root note. The next note of a minor triad " +
                    " is three half steps (semitones) above the root. The last note of the minor triad is two whole steps " +
                    " (two tones) from the middle note. " +
                    "The examples below show different patterns for an A minor triad chord. These patterns are identical for " +
                    "all minor triad chords.",

                "notes": ["A", "C", "E"],
                "stringCombos": [{
                    "stringTitle": "1st, 2nd and 3rd",

                    "positions": [{
                        "notesAtPosition": [
                            {n: 'A', s: 3, f: 2},
                            {n: 'C', s: 2, f: 1},
                            {n: 'E', s: 1, f: 0},]
                    },
                        {
                            "notesAtPosition": [
                                {n: 'C', s: 3, f: 5},
                                {n: 'E', s: 2, f: 5},
                                {n: 'A', s: 1, f: 5},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'E', s: 3, f: 9},
                                {n: 'A', s: 2, f: 10},
                                {n: 'C', s: 1, f: 8},]
                        },
                    ]
                },
                    {
                        "stringTitle": "2nd, 3rd and 4th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'E', s: 4, f: 2},
                                {n: 'A', s: 3, f: 2},
                                {n: 'C', s: 2, f: 1},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'A', s: 4, f: 7},
                                    {n: 'C', s: 3, f: 5},
                                    {n: 'E', s: 2, f: 5},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'E', s: 3, f: 9},
                                    {n: 'A', s: 2, f: 10},]
                            },

                        ]
                    },
                    {
                        "stringTitle": "3rd, 4th and 5th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'C', s: 5, f: 3},
                                {n: 'E', s: 4, f: 2},
                                {n: 'A', s: 3, f: 2},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 5, f: 7},
                                    {n: 'A', s: 4, f: 7},
                                    {n: 'C', s: 3, f: 5},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'A', s: 5, f: 12},
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'E', s: 3, f: 9},]
                            },
                        ]
                    },
                    {
                        "stringTitle": "4th, 5th and 6th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'A', s: 6, f: 5},
                                {n: 'C', s: 5, f: 3},
                                {n: 'E', s: 4, f: 2},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 6, f: 8},
                                    {n: 'E', s: 5, f: 7},
                                    {n: 'A', s: 4, f: 7},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 6, f: 12},
                                    {n: 'A', s: 5, f: 12},
                                    {n: 'C', s: 4, f: 10},]
                            },
                        ]
                    }
                ]
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }

    majortriads() {
        let notes =
            {
                "mainTitle": "Major",
                "helpLink":this._linkService.THEORY_TRI_MAJ,
                "detail": "Major triad chords begin at the root note. The next note of a major triad " +
                    " two whole steps (two tones) above the root. The last note of the major triad is three half steps " +
                    " (three semitones) from the middle note. " +
                    "The examples below show different patterns for a C major chord. These patterns are identical for " +
                    "all major triad chords.",

                "notes": ["C", "E", "G"],
                "stringCombos": [{
                    "stringTitle": "1st, 2nd and 3rd",

                    "positions": [{
                        "notesAtPosition": [
                            {n: 'C', s: 3, f: 5},
                            {n: 'E', s: 2, f: 5},
                            {n: 'G', s: 1, f: 3},]
                    },
                        {
                            "notesAtPosition": [
                                {n: 'E', s: 3, f: 9},
                                {n: 'G', s: 2, f: 8},
                                {n: 'C', s: 1, f: 8},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'G', s: 3, f: 12},
                                {n: 'C', s: 2, f: 13},
                                {n: 'E', s: 1, f: 12},]
                        },
                    ]
                },
                    {
                        "stringTitle": "2nd, 3rd and 4th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'G', s: 4, f: 5},
                                {n: 'C', s: 3, f: 5},
                                {n: 'E', s: 2, f: 5},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'E', s: 3, f: 9},
                                    {n: 'G', s: 2, f: 8},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 4, f: 14},
                                    {n: 'G', s: 3, f: 12},
                                    {n: 'C', s: 2, f: 13},]
                            },

                        ]
                    },
                    {
                        "stringTitle": "3rd, 4th and 5th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'E', s: 5, f: 7},
                                {n: 'G', s: 4, f: 5},
                                {n: 'C', s: 3, f: 5},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'G', s: 5, f: 10},
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'E', s: 3, f: 9},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 5, f: 15},
                                    {n: 'E', s: 4, f: 14},
                                    {n: 'G', s: 3, f: 12},]
                            },
                        ]
                    },
                    {
                        "stringTitle": "4th, 5th and 6th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'C', s: 6, f: 8},
                                {n: 'E', s: 5, f: 7},
                                {n: 'G', s: 4, f: 5},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 6, f: 12},
                                    {n: 'G', s: 5, f: 10},
                                    {n: 'C', s: 4, f: 10},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'G', s: 6, f: 15},
                                    {n: 'C', s: 5, f: 15},
                                    {n: 'E', s: 4, f: 14},]
                            },
                        ]
                    }
                ]
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }

    getMajMinDimLinks() {
        return (
            <div>
                Please refer to these links for each type of triad.<br/><br/>
                <b><a href={this._linkService.THEORY_TRI_MAJ}>Major triads</a></b><br/>
                <b><a href={this._linkService.THEORY_TRI_MIN}>Minor triads</a></b><br/>
                <b><a href={this._linkService.THEORY_TRI_DIM}>Diminished triads</a></b><br/><br/>

            </div>
        )
    }
    majMinDimTriads() {
        let notes =
            {
                "mainTitle": "Major, Minor and Diminished",
                "helpLink":this._linkService.THEORY_TRI_MAJ_MIN_DIM,
                "detail": this.getMajMinDimLinks(),
                "stringCombos":[],
                "notes": ["C", "E", "G"],
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }
    sus2triads() {
        let notes =
            {
                "mainTitle": "Suspended 2",
                "helpLink":this._linkService.THEORY_TRI_SUS2,
                "detail": "Suspended 2 (sus2) triad chords are created from major or minor triad " +
                    "chords. The middle note of the triad is shifted down by one note in the current " +
                    "scale. " + " For example, a C major chord, CEG, becomes CDG. " +
                    "The examples below show different patterns for a sus2 triad chord. " +
                    "These patterns are identical for " +
                    "all sus2 chords.",

                "notes": ["C", "D", "G"],
                "stringCombos": [{
                    "stringTitle": "1st, 2nd and 3rd",

                    "positions": [{
                        "notesAtPosition": [
                            {n: 'C', s: 3, f: 5},
                            {n: 'D', s: 2, f: 3},
                            {n: 'G', s: 1, f: 3},]
                    },
                        {
                            "notesAtPosition": [
                                {n: 'D', s: 3, f: 7},
                                {n: 'G', s: 2, f: 8},
                                {n: 'C', s: 1, f: 8},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'G', s: 3, f: 12},
                                {n: 'C', s: 2, f: 13},
                                {n: 'D', s: 1, f: 10},]
                        },
                    ]
                },
                    {
                        "stringTitle": "2nd, 3rd and 4th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'G', s: 4, f: 5},
                                {n: 'C', s: 3, f: 5},
                                {n: 'D', s: 2, f: 3},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'D', s: 3, f: 7},
                                    {n: 'G', s: 2, f: 8},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'G', s: 3, f: 12},
                                    {n: 'C', s: 2, f: 13},]
                            },

                        ]
                    },
                    {
                        "stringTitle": "3rd, 4th and 5th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'D', s: 5, f: 5},
                                {n: 'G', s: 4, f: 5},
                                {n: 'C', s: 3, f: 5},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'G', s: 5, f: 10},
                                    {n: 'C', s: 4, f: 10},
                                    {n: 'D', s: 3, f: 7},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'C', s: 5, f: 15},
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'G', s: 3, f: 12},]
                            },
                        ]
                    },
                    {
                        "stringTitle": "4th, 5th and 6th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'C', s: 6, f: 8},
                                {n: 'D', s: 5, f: 5},
                                {n: 'G', s: 4, f: 5},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 6, f: 10},
                                    {n: 'G', s: 5, f: 10},
                                    {n: 'C', s: 4, f: 10},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'G', s: 6, f: 15},
                                    {n: 'C', s: 5, f: 15},
                                    {n: 'D', s: 4, f: 12},]
                            },
                        ]
                    }

                ]
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }

    sus4triads() {
        let notes =
            {
                "mainTitle": "Suspended 4",
                "helpLink":this._linkService.THEORY_TRI_SUS4,
                "detail": "Suspended 4 (sus4) triad chords are created from major or minor triad " +
                    "chords. The middle note of the triad is shifted up by one note in the current " +
                    "scale. " + " For example, am A minor chord, ACE, becomes ADE. " +
                    "The examples below show different patterns for a sus4 triad chord. " +
                    "These patterns are identical for all sus4 chords.",

                "notes": ["A", "D", "E"],
                "stringCombos": [{
                    "stringTitle": "1st, 2nd and 3rd",

                    "positions": [{
                        "notesAtPosition": [
                            {n: 'A', s: 3, f: 2},
                            {n: 'D', s: 2, f: 3},
                            {n: 'E', s: 1, f: 0},]
                    },
                        {
                            "notesAtPosition": [
                                {n: 'D', s: 3, f: 7},
                                {n: 'E', s: 2, f: 5},
                                {n: 'A', s: 1, f: 5},]
                        },
                        {
                            "notesAtPosition": [
                                {n: 'E', s: 3, f: 9},
                                {n: 'A', s: 2, f: 10},
                                {n: 'D', s: 1, f: 10},]
                        },
                    ]
                },
                    {
                        "stringTitle": "2nd, 3rd and 4th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'E', s: 4, f: 2},
                                {n: 'A', s: 3, f: 2},
                                {n: 'D', s: 2, f: 3},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'A', s: 4, f: 7},
                                    {n: 'D', s: 3, f: 7},
                                    {n: 'E', s: 2, f: 5},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'E', s: 3, f: 9},
                                    {n: 'A', s: 2, f: 10},]
                            },

                        ]
                    },
                    {
                        "stringTitle": "3rd, 4th and 5th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'D', s: 5, f: 5},
                                {n: 'E', s: 4, f: 2},
                                {n: 'A', s: 3, f: 2},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 5, f: 7},
                                    {n: 'A', s: 4, f: 7},
                                    {n: 'D', s: 3, f: 7},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'A', s: 5, f: 12},
                                    {n: 'D', s: 4, f: 12},
                                    {n: 'E', s: 3, f: 9},]
                            },
                        ]
                    },
                    {
                        "stringTitle": "4th, 5th and 6th",
                        "positions": [{
                            "notesAtPosition": [
                                {n: 'A', s: 6, f: 5},
                                {n: 'D', s: 5, f: 5},
                                {n: 'E', s: 4, f: 2},]
                        },
                            {
                                "notesAtPosition": [
                                    {n: 'D', s: 6, f: 10},
                                    {n: 'E', s: 5, f: 7},
                                    {n: 'A', s: 4, f: 7},]
                            },
                            {
                                "notesAtPosition": [
                                    {n: 'E', s: 6, f: 12},
                                    {n: 'A', s: 5, f: 12},
                                    {n: 'D', s: 4, f: 12},]
                            },
                        ]
                    }
                ]
            }
        notes = this.addColorAndPaddingFrets(notes)
        return notes;
    }
}
